import { ArrayHelper } from "../../../../../../../utilities/contracts/array-helper";
import { DateHelper } from "../../../../../../../utilities/contracts/date-helper";
import { StringHelper } from "../../../../../../../utilities/contracts/string-helper";
import { IAddressClaimDiagnosis, IAddressClaimDiagnosisRow, IAddressClaimDisplay, IAddressClaimSummary } from "./address-claim-summary.model";

export class AddressClaimSummaryHelper {
  static readonly maxVisibleClaims = 1;

  // Filters out claims the UI can't usefully render, and precomputes the visible/overflow
  // split and diagnosis rows once per row load instead of recomputing them on every
  // change-detection cycle from the template.
  static setDisplayClaims(row: any): void {
    const claims: IAddressClaimDisplay[] = ArrayHelper.isAvailable(row.claims)
      ? row.claims
        .filter((claim: IAddressClaimSummary) => StringHelper.isAvailable(claim.claimNumber) && ArrayHelper.isAvailable(claim.diagnoses))
        .map((claim: IAddressClaimSummary) => ({ ...claim, diagnosisRows: this.getDiagnosisRows(claim) }))
      : [];
    row.claims = claims;
    row.visibleClaims = claims.slice(0, this.maxVisibleClaims);
    row.extraClaims = claims.slice(this.maxVisibleClaims);
    row.hasExtraClaims = row.extraClaims.length > 0;
  }

  private static getDiagnosisRows(claim: IAddressClaimSummary): IAddressClaimDiagnosisRow[] {
    return claim.diagnoses.map(diagnosis => this.getDiagnosisRow(diagnosis));
  }

  private static getDiagnosisRow(diagnosis: IAddressClaimDiagnosis): IAddressClaimDiagnosisRow {
    const dos = diagnosis.encounterStartDate === diagnosis.encounterEndDate
      ? DateHelper.format(diagnosis.encounterStartDate)
      : `${DateHelper.format(diagnosis.encounterStartDate)} - ${DateHelper.format(diagnosis.encounterEndDate)}`;
    return {
      dos,
      icdCode: diagnosis.icdCode,
      icdDescription: diagnosis.icdDescription,
      providerName: diagnosis.providerName,
    };
  }
}
